import React from 'react';
import _ from 'lodash';
import { Col, Row } from 'reactstrap';
import Parse from 'parse';
import cn from 'classnames';
import Fade from 'react-reveal/Fade';
import withStyles from 'isomorphic-style-loader/withStyles';

import { ErrorAlert } from 'helpers/alert';
import handleParseError from 'helpers/handleParseError';
import Link from 'components/Link';

import s from './Videos.scss';

class Videos extends React.Component {
  constructor() {
    super();
    this.state = {
      fadeIn: false,
      videos: [],
    };
  }

  componentDidMount() {
    if (_.isEmpty(this.state.videos)) {
      const query = new Parse.Query('Video');
      query.addAscending('title');
      query
        .find()
        .then(videos => {
          this.setState({ fadeIn: true, videos });
        })
        .catch(
          handleParseError(error => {
            ErrorAlert(error.message);
          }),
        );
    } else {
      this.setState({ fadeIn: true });
    }
  }

  render() {
    return (
      <div className={s.root}>
        <div className={cn([s.specialtyContainer, 'py-5'])}>
          {this.state.videos.length > 0 ? (
            <Fade bottom when={this.state.fadeIn}>
              <Row>
                <Col lg={12} className="page-header text-center">
                  <h2 style={{ color: 'black' }}>Instructional Videos</h2>
                </Col>
              </Row>
              {_.map(this.state.videos, video => (
                <Row className="justify-content-center">
                  <Col sm={6} className="text-center">
                    <Link
                      to={`/videos/play/${video.get('title')}/${video.get(
                        'playbackId',
                      )}/${video.get('shortLink')}`}
                    >
                      {video.get('title')}
                    </Link>
                  </Col>
                </Row>
              ))}
            </Fade>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Videos);
